export const NAV = {
    logoLink: "nav-logo-link",
    desktopHome: "nav-desktop-home",
    desktopAbout: "nav-desktop-about",
    desktopServices: "nav-desktop-services",
    desktopApproach: "nav-desktop-approach",
    desktopFaq: "nav-desktop-faq",
    desktopContact: "nav-desktop-contact",
    desktopApplyCta: "nav-desktop-apply-cta",
    mobileOpen: "nav-mobile-open",
    mobileClose: "nav-mobile-close",
    mobileOverlay: "nav-mobile-overlay",
    mobileHome: "nav-mobile-home",
    mobileAbout: "nav-mobile-about",
    mobileServices: "nav-mobile-services",
    mobileApproach: "nav-mobile-approach",
    mobileFaq: "nav-mobile-faq",
    mobileContact: "nav-mobile-contact",
    stickyApplyCta: "sticky-mobile-apply-cta",
};

export const HERO = {
    section: "hero-section",
    eyebrow: "hero-eyebrow",
    headline: "hero-headline",
    subheadline: "hero-subheadline",
    primaryCta: "hero-primary-cta",
    secondaryCta: "hero-secondary-cta",
};

export const PATHWAY = {
    section: "dual-pathway-section",
    reversalCard: "pathway-reversal-card",
    longevityCard: "pathway-longevity-card",
    reversalCta: "pathway-reversal-cta",
    longevityCta: "pathway-longevity-cta",
};

export const APPLY = {
    page: "apply-page",
    progressBar: "apply-progress",
    stepObjectiveReversal: "apply-objective-reversal",
    stepObjectiveLongevity: "apply-objective-longevity",
    reversalFocusPcos: "apply-reversal-focus-pcos",
    reversalFocusMetabolic: "apply-reversal-focus-metabolic",
    reversalFocusCardiac: "apply-reversal-focus-cardiac",
    reversalSymptomDuration: "apply-reversal-symptom-duration",
    longevityFocusBiomarkers: "apply-longevity-focus-biomarkers",
    longevityFocusCellular: "apply-longevity-focus-cellular",
    longevityFocusCardio: "apply-longevity-focus-cardio",
    longevityWearable: "apply-longevity-wearable",
    formatInClinic: "apply-format-in-clinic",
    formatHybrid: "apply-format-hybrid",
    formatVirtual: "apply-format-virtual",
    commitmentYes: "apply-commitment-yes",
    commitmentExplore: "apply-commitment-explore",
    contactName: "apply-contact-name",
    contactEmail: "apply-contact-email",
    contactPhone: "apply-contact-phone",
    contactCity: "apply-contact-city",
    uploadHint: "apply-upload-hint",
    nextBtn: "apply-next-btn",
    backBtn: "apply-back-btn",
    submitBtn: "apply-submit-btn",
    loadingState: "apply-loading-state",
    successScreen: "apply-success-screen",
    successEmail: "apply-success-email-cta",
    successWhatsapp: "apply-success-whatsapp-cta",
};

export const CONTACT = {
    page: "contact-page",
    emailLink: "contact-email-link",
    phoneLink: "contact-phone-link",
    whatsappLink: "contact-whatsapp-link",
    instagramLink: "contact-instagram-link",
    linkedinLink: "contact-linkedin-link",
};

export const FOOTER = {
    root: "footer-root",
    applyCta: "footer-apply-cta",
};
